const baseUrl = {
	lucree: `${process.env.REACT_APP_API_LUCREE}`,
	hierarquia: `${process.env.REACT_APP_API_LUCREE_HIERARQUIA}`,
	conciliacao: `${process.env.REACT_APP_API_CONCILIACAO}`,
	liquidacao: `${process.env.REACT_APP_API_LIQUIDACAO}`,
	cep: `${process.env.REACT_APP_API_VIACEP}`,
	comercial: `${process.env.REACT_APP_API_LUCREE_COMERCIAL}`,
	kyc: `${process.env.REACT_APP_API_LUCREE_KYC}`,
	transacao: `${process.env.REACT_APP_API_TRANSACAO}`,
	gatewayPagamentos: `${process.env.REACT_APP_API_GATEWAY_PAGAMENTOS}`,
	grupos: `${process.env.REACT_APP_API_GRUPOS}`,
	split: `${process.env.REACT_APP_API_LUCREE_SPLIT}`,
	fiscal: `${process.env.REACT_APP_API_FISCAL}`,
	export: `${process.env.REACT_APP_API_EXPORT}`,
	extrato: `${process.env.REACT_APP_API_EXTRATO}`,
	saldo: `${process.env.REACT_APP_API_SALDO}`,
	pedido: `${process.env.REACT_APP_API_PEDIDO}`,
	solicitacao: `${process.env.REACT_APP_API_SOLICITACAO}`,
	resumo: `${process.env.REACT_APP_API_CRED_REVENDA}`,
	consultaRevendas: `${process.env.REACT_APP_API_CONSULTA_REVENDAS}`,
	lancamentos: `${process.env.REACT_APP_API_LANCAMENTOS}`,
	mensageria: `${process.env.REACT_APP_API_MENSAGERIA}`,
	pgm: `${process.env.REACT_APP_API_PGM}`,
	onboarding: `${process.env.REACT_APP_API_ONBOARDING}`,
	programaMercado: `${process.env.REACT_APP_API_PROGRAMA_MERCADO}`,
	planos: `${process.env.REACT_APP_API_PLANOS}`,
	simulador: `${process.env.REACT_APP_API_SIMULADOR}`,
	token: `${process.env.REACT_APP_TOKEN}`
};

export default baseUrl;
